import styled, { css } from 'styled-components';

export const SectionContainer = styled.div`
  ${({ theme: { media, spacing } }) => css`
    margin: 0 ${spacing.s3};

    ${media.up('slim')} {
      max-width: 704px;
      margin: 0 auto;
    }

    ${media.up('big')} {
      max-width: 1125px;
    }
  `}
`;
